import { SpcInstance, WmsInstance } from "@/instance/axios";
import {
  createMutationKeys,
  createQueryKeys,
  mergeQueryKeys,
} from "@lukemorales/query-key-factory";
import {
  SpcApiIncomingInspectionsFindPostRequest,
  SpcApiIncomingInspectionsGetRequest,
  SpcApiIncomingInspectionsIncomingInspectionIdDeleteRequest,
  SpcApiIncomingInspectionsIncomingInspectionIdPutRequest,
  SpcApiIncomingInspectionsPostRequest,
} from "@sizlcorp/sizl-api-document/dist/models";

export const INCOMING_INSPECTION_KEY = "incomingInspection";

export const incomingInspection = createQueryKeys(INCOMING_INSPECTION_KEY, {
  all: null,
  get: (params: SpcApiIncomingInspectionsGetRequest) => {
    const queryParams = {
      ...params,
      query: JSON.stringify({ $and: params?.query }),
      sort: params.sort?.length ? params.sort : "-id",
    }; // Grade 조회 시 기본 정렬 표시

    return {
      queryKey: [queryParams, JSON.stringify(queryParams)],
      queryFn: () => SpcInstance.incomingInspectionsGet(queryParams),
    };
  },
  find: (params: SpcApiIncomingInspectionsFindPostRequest) => {
    const queryParams = {
      ...params,
      query: JSON.stringify({ $and: params?.query }),
      sort: params.sort?.length ? params.sort : "-id",
    }; // Grade 조회 시 기본 정렬 표시

    return {
      queryKey: [queryParams, JSON.stringify(queryParams)],
      queryFn: () => SpcInstance.incomingInspectionsFindPost(queryParams),
    };
  },
  flatGet: (params: SpcApiIncomingInspectionsGetRequest) => {
    const queryParams = {
      ...params,
      query: JSON.stringify({ $and: params?.query }),
      sort: params.sort?.length ? params.sort : "-id",
    }; // Grade 조회 시 기본 정렬 표시

    return {
      queryKey: [queryParams, JSON.stringify(queryParams)],
      queryFn: () => WmsInstance.incomingInspectionWithItemGradeGet(queryParams),
    };
  },
});

export const mutateIncomingInspection = createMutationKeys(INCOMING_INSPECTION_KEY, {
  create: (params: SpcApiIncomingInspectionsPostRequest) => ({
    mutationKey: [params.incomingInspectionsGetRequest],
    mutationFn: () => SpcInstance.incomingInspectionsPost(params),
  }),
  update: (params: SpcApiIncomingInspectionsIncomingInspectionIdPutRequest) => ({
    mutationKey: [params.incomingInspectionId, params.incomingInspectionsGetRequest],
    mutationFn: () => SpcInstance.incomingInspectionsIncomingInspectionIdPut(params),
  }),
  delete: (params: SpcApiIncomingInspectionsIncomingInspectionIdDeleteRequest) => ({
    mutationKey: [params.incomingInspectionId],
    mutationFn: () => SpcInstance.incomingInspectionsIncomingInspectionIdDelete(params),
  }),
});

export const itemCategoriesQueryKeys = mergeQueryKeys(incomingInspection, mutateIncomingInspection);
